import React, { useState } from "react"
import { Header, Item } from "../Components/Navigation"
import TC from "../termsAndConditionsState"
import {
  LEGAL_CONST,
  PRIVACY_POLICY_SECTIONS,
  AUTH_LEGAL_SECTIONS,
  KAIZEN_HUB_ROUTE,
} from "../constants"

export default ({ history, tcManager }: { history: object; tcManager: TC }) => {
  const page = `${LEGAL_CONST}/${KAIZEN_HUB_ROUTE}`
  const privacyPolicySection = `${page}/Privacy Policy`

  const termsAndConditionsSection = `${page}/Terms and Conditions`
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false)
  const togglePrivacyPolicyOpen = (e: object) => {
    e.stopPropagation()
    setPrivacyPolicyOpen(!privacyPolicyOpen)
  }

  return (
    <>
      <span>{Header(`/${page}`)}</span>
      <ul style={{ paddingLeft: "0" }}>
        {Item({ path: `/${termsAndConditionsSection}`, history })}
      </ul>
      <div
        className="legal-sidenav-list-item focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        onClick={togglePrivacyPolicyOpen}
        data-testid="legal-sidenav-list-item"
        role="button"
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            togglePrivacyPolicyOpen(event)
          }
        }}
        tabIndex={0}
      >
        {Header(privacyPolicySection)}

        {privacyPolicyOpen && (
          <div className="legal-sidenav-second-tier">
            {PRIVACY_POLICY_SECTIONS.map((pp_section: string) => (
              <ul style={{ paddingLeft: "0" }} key={pp_section}>
                {Item({ path: `/${page}${pp_section}`, history })}{" "}
              </ul>
            ))}
          </div>
        )}
      </div>
      <ul style={{ paddingLeft: "0" }}>
        {AUTH_LEGAL_SECTIONS.map((al_section: string) =>
          Item({
            path: `/${page}/${al_section}`,
            history,
          })
        )}
      </ul>
      <ul style={{ paddingLeft: "0" }}>
        {tcManager.nonThemeModules.map(({ name }: { name: string }) =>
          Item({ path: `/${page}/${name}`, history })
        )}
      </ul>
    </>
  )
}
